import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { getCardType } from './paymentIcon.settings';
import { Icon } from '../../Icon';
export const PaymentIcon = ({ cardNumber, className, disabled }) => {
    const iconClassName = 'flex w-6 h-6';
    const parseIcon = (number) => {
        if (number) {
            const icon = getCardType(number);
            switch (icon) {
                case 'visa':
                    return _jsx(Icon, { className: iconClassName, name: disabled ? 'visa-alt' : 'visa' });
                case 'master_card':
                    return (_jsx(Icon, { className: iconClassName, name: disabled ? 'mastercard-alt' : 'mastercard' }));
                case 'american_express':
                    return _jsx(Icon, { className: iconClassName, name: disabled ? 'amex-alt' : 'amex' });
                case 'discover':
                    return _jsx(Icon, { className: iconClassName, name: disabled ? 'discover-alt' : 'discover' });
                default:
                    return null;
            }
        }
        return (_jsxs(_Fragment, { children: [_jsx(Icon, { className: iconClassName, name: disabled ? 'visa-alt' : 'visa' }), _jsx(Icon, { className: iconClassName, name: disabled ? 'mastercard-alt' : 'mastercard' }), _jsx(Icon, { className: iconClassName, name: disabled ? 'amex-alt' : 'amex' }), _jsx(Icon, { className: iconClassName, name: disabled ? 'discover-alt' : 'discover' })] }));
    };
    return _jsx("div", { className: className, children: parseIcon(cardNumber) });
};
